import React from 'react'

import formatter from '@/services/formatter'
import { unmask } from '@/services/masks'

import {
  AccountCircle as AccountIcon,
  LocalShipping as CarrierIcon,
  Description as CollectIcon,
} from '@material-ui/icons'
import { alpha, Box, Divider, styled, Typography } from '@material-ui/core'
import { colors } from '@/theme'

// --------------------------------------------------------------------------

export function CollectPrintCards(props) {
  const { data: collect } = props

  if (!collect) return null

  return (
    <Box
      display="grid"
      gridTemplateColumns="repeat(3, 1fr)"
      gridGap="1rem"
      mt="1rem"
    >
      <Card Icon={AccountIcon} title="Motorista">
        <Typography variant="body1">{collect.driver.name}</Typography>

        <Typography variant="body2" color="textSecondary">
          {formatter(unmask(collect.driver.id)).toCNPJorCPF()}
        </Typography>
      </Card>

      <Card Icon={CarrierIcon} title="Caminhão">
        <Typography variant="body1">{collect.truck.plate}</Typography>

        <Typography variant="body2" color="textSecondary">
          {collect.truck.dsc_caminhao}
        </Typography>
      </Card>

      <Card Icon={CollectIcon} title="Agendamento">
        <Typography variant="body1">{collect.prevDate}</Typography>

        <Typography variant="body2" color="textSecondary">
          {collect.obs || '-'}
        </Typography>
      </Card>
    </Box>
  )
}

// --------------------------------------------------------------------------

const StyledIconContainer  =styled(Box)(() => ({ 
  '@media print':  {
    display: 'none'
  }
}))

function Card(props) {
  const { Icon, title, children } = props

  return (
    <Box
      bgcolor={alpha(colors.color100, 0.16)}
      p={2}
      pl={3}
      borderRadius={6}
      display="flex"
      alignItems="center"
      gridGap="1rem"
    >
      <StyledIconContainer
        display="flex"
        alignItems="center"
        justifyContent="center"
        color="primary.main"
      >
        <Icon fontSize="large" />
      </StyledIconContainer>

      <Divider flexItem orientation="vertical" />

      <Box display="flex" flexDirection="column">
        <Typography
          color="primary"
          component="span"
          variant="body2"
          style={{
            fontWeight: 600,
            textTransform: 'uppercase',
          }}
          gutterBottom
        >
          {title}
        </Typography>

        <Box>{children}</Box>
      </Box>
    </Box>
  )
}
